<template>
  <div style="height: 100%">

  </div>
</template>

<script>
export default {
name: "BarChartWidgetSkeleton"
}
</script>

<style scoped>
  .chart-skeleton {
    height: 100%;
  }
</style>